<div class="layout">
  <div class="image">{{ menuItem.categoryName }}</div>
  <div class="name">{{ menuItem.nameEn }}</div>
  <div class="price">{{ Code() }}</div>
  <div class="edit">
    <div (click)="onDelete(Id())">
      <svg class="icon icon__delete">
        <use xlink:href="images/sprites5.svg#icon-bin2"></use>
      </svg>
    </div>

    @if(newisVisible()){
    <div (click)="onIconClick(Id())">
      <svg class="icon icon__hide">
        <use xlink:href="images/sprites5.svg#icon-eye"></use>
      </svg>
    </div>

    } @else{
    <div (click)="onIconClick(Id())">
      <svg class="icon icon__hide">
        <use xlink:href="images/sprites5.svg#icon-eye-blocked"></use>
      </svg>
    </div>

    }
  </div>
</div>
